import { render, staticRenderFns } from "./UserMasterSearch.vue?vue&type=template&id=96f8f1be"
import script from "./UserMasterSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserMasterSearch.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports